module.exports = __webpack_public_path__ + "static/media/pdfIcon.261b5ea4.svg";